import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import SectionPage from "@/pages/SectionPage";
import ArticlePage from "@/pages/ArticlePage";
import AboutPage from "@/pages/AboutPage";
import SearchPage from "@/pages/SearchPage";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminEditor from "@/pages/admin/AdminEditor";
import AdminAbout from "@/pages/admin/AdminAbout";
import AdminVisits from "@/pages/admin/AdminVisits";
import AdminSubscribers from "@/pages/admin/AdminSubscribers";
import AdminMessages from "@/pages/admin/AdminMessages";
import ContactPage from "@/pages/ContactPage";
import { SeriesIndex, SeriesPage } from "@/pages/SeriesPages";
import NewsletterAction from "@/pages/NewsletterAction";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route index element={<Home />} />
            <Route path="section/:slug" element={<SectionPage />} />
            <Route path="article/:slug" element={<ArticlePage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="search" element={<SearchPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="series" element={<SeriesIndex />} />
            <Route path="series/:slug" element={<SeriesPage />} />
            <Route path="newsletter/confirm" element={<NewsletterAction action="confirm" key="confirm" />} />
            <Route path="newsletter/unsubscribe" element={<NewsletterAction action="unsubscribe" key="unsubscribe" />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route element={<AuthProvider><Outlet /></AuthProvider>}>
            <Route path="admin/login" element={<AdminLogin />} />
            <Route path="admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="new" element={<AdminEditor key="new" />} />
              <Route path="edit/:id" element={<AdminEditor key="edit" />} />
              <Route path="about" element={<AdminAbout />} />
              <Route path="visits" element={<AdminVisits />} />
              <Route path="subscribers" element={<AdminSubscribers />} />
              <Route path="messages" element={<AdminMessages />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" toastOptions={{ style: { borderRadius: 0, fontFamily: "var(--font-ui)" } }} />
    </>
  );
}

export default App;
